"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _listings = require("../../../constants/listings");
var _config = _interopRequireDefault(require("../../../config"));
var _AconctListingConnectionSection = _interopRequireDefault(require("./AconctListingConnectionSection"));
var _AdvisrListingConnectionSection = _interopRequireDefault(require("../common/AdvisrListingConnectionSection"));
var _SAPStoreListingConnectionSection = _interopRequireDefault(require("../common/SAPStoreListingConnectionSection"));
var _CocpapListingConnectionSection = _interopRequireDefault(require("./CocpapListingConnectionSection"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// This is the component used for the connection section if there is no user logged in

// In the in-product App Center site, there is one factor that will wildy change what is rendered
// in the connect button section: What the listingType field is.
// We separate the three cases with this component and the children handle the subcases.
// The cases are:
// 1. ACONCT
// 2. ADVISR
// 3. COCPAP
// https://github.concur.com/appcenter/docs/wiki/Important-Listings-Fields#corelistingtype
function InProductConnectionSection(_ref) {
  var listing = _ref.listing,
    isDisabled = _ref.isDisabled,
    trackButtonClick = _ref.trackButtonClick,
    trackLinkClick = _ref.trackLinkClick,
    userPrefs = _ref.userPrefs,
    toggleModal = _ref.toggleModal,
    checkForConnection = _ref.checkForConnection,
    isConnecting = _ref.isConnecting,
    handleRequestInformationClick = _ref.handleRequestInformationClick,
    launchTermsAndConditionsModal = _ref.launchTermsAndConditionsModal,
    disconnectFromListing = _ref.disconnectFromListing,
    profile = _ref.profile,
    onConnectListingConnectClick = _ref.onConnectListingConnectClick,
    handleSAPStoreButtonClick = _ref.handleSAPStoreButtonClick;
  var listingType = listing.core.listingType,
    ID = listing.ID;
  var companyUUID = userPrefs.companyUUID,
    isTestEntity = userPrefs.isTestEntity;
  var isJouleListing = _config.default.nui.jouleListingId === ID;
  if (listingType === _listings.LISTING_TYPES.ACONCT) {
    return /*#__PURE__*/_react.default.createElement(_AconctListingConnectionSection.default, {
      listing: listing,
      trackButtonClick: trackButtonClick,
      toggleModal: toggleModal,
      checkForConnection: checkForConnection,
      isDisabled: isDisabled,
      isConnecting: isConnecting,
      companyUUID: companyUUID,
      disconnectFromListing: disconnectFromListing
    });
  }
  if (listingType === _listings.LISTING_TYPES.ADVISR) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "loyalty-box"
    }, isJouleListing ? /*#__PURE__*/_react.default.createElement(_SAPStoreListingConnectionSection.default, {
      onButtonClick: handleSAPStoreButtonClick,
      onSecondaryLinkClick: handleRequestInformationClick,
      listingId: ID
    }) : /*#__PURE__*/_react.default.createElement(_AdvisrListingConnectionSection.default, {
      onRequestInformationClick: handleRequestInformationClick,
      listingId: ID
    }));
  }
  if (listingType === _listings.LISTING_TYPES.COCPAP) {
    return /*#__PURE__*/_react.default.createElement(_CocpapListingConnectionSection.default, {
      listing: listing,
      trackButtonClick: trackButtonClick,
      launchTermsAndConditionsModal: launchTermsAndConditionsModal,
      companyUUID: companyUUID,
      disconnectFromListing: disconnectFromListing,
      toggleModal: toggleModal,
      isConnecting: isConnecting,
      trackLinkClick: trackLinkClick,
      profile: profile,
      handleRequestInformationClick: handleRequestInformationClick,
      onConnect: onConnectListingConnectClick,
      isDisabled: isDisabled,
      isTestEntity: isTestEntity
    });
  }
  throw Error('This component currently only supports ACONCT (Enroll), COCPAP (Connect), or ADVISR (Inquire) listings');
}
InProductConnectionSection.propTypes = {
  listing: _propTypes.default.shape({
    core: _propTypes.default.shape({
      listingType: _propTypes.default.string.isRequired
    }).isRequired,
    ID: _propTypes.default.string.isRequired
  }).isRequired,
  isDisabled: _propTypes.default.bool,
  trackButtonClick: _propTypes.default.func.isRequired,
  trackLinkClick: _propTypes.default.func.isRequired,
  userPrefs: _propTypes.default.shape({
    companyUUID: _propTypes.default.string.isRequired,
    isTestEntity: _propTypes.default.bool
  }).isRequired,
  toggleModal: _propTypes.default.func.isRequired,
  checkForConnection: _propTypes.default.func.isRequired,
  isConnecting: _propTypes.default.bool,
  handleRequestInformationClick: _propTypes.default.func.isRequired,
  handleSAPStoreButtonClick: _propTypes.default.func,
  profile: _propTypes.default.shape({
    Role: _propTypes.default.number
  }).isRequired,
  onConnectListingConnectClick: _propTypes.default.func.isRequired,
  disconnectFromListing: _propTypes.default.func.isRequired,
  launchTermsAndConditionsModal: _propTypes.default.func.isRequired
};
var _default = exports.default = InProductConnectionSection;